
export default {
    name: 'atcd-historique-neonatologie',
    components: {},
    props: ["consultation", "activeRole", "is_printable"],
    data() {
        return {
            is_loading: true,
            histo_is_empty: false,
            visible_collapse: 1,
        }
    },
    computed: {
        antecedent_neonatologie_historique() {
            return this.$store.getters["antecedent_neonatologie_historique"];
        },
    },
    mounted() {
        this.listeChampATCDNeonatologie()
    },
    methods: {
        async listeChampATCDNeonatologie() {
            this.is_loading = true
            
            let filter_data = {
                consultation_id: this.consultation.id,
                data_type: 'antecedent_neonatologie',
                est_en_cours: false
            }

            this.$store.dispatch('getConsultationAntecedent', filter_data).then(() => {
                if (this.antecedent_neonatologie_historique.length == 0) {
                    this.histo_is_empty = true
                } else {
                    this.histo_is_empty = false
                }
                this.is_loading = false
            })
        },

        toggleSection(value) {
            this.visible_collapse = value
        },
    }
}


